// Authenticated NDJSON transport for incremental assistant replies.
const authorizedPostStream = async (
  functionName: string,
  body: Record<string, unknown> = {},
  { onDelta, signal }: { onDelta?: (delta: string) => void; signal?: AbortSignal } = {},
) => {
  const token = await runtime.auth.currentUser?.getIdToken()
  if (!token) throw new Error(t('svc.mustBeSignedIn'))
  const response = await fetch(functionUrl(functionName), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/x-ndjson', Authorization: `Bearer ${token}`, ...(await window.PlummeAppCheck?.headers?.()) },
    body: JSON.stringify({ ...body, stream: true }),
    ...(signal ? { signal } : {}),
  })
  if (!response.ok) {
    const payload = await response.json().catch(() => null)
    throw new Error(payload?.message || payload?.error || `HTTP ${response.status}`)
  }
  if (!response.body?.getReader) throw new Error(t('svc.requestTimedOut'))

  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''
  let finalReply: Record<string, unknown> | null = null
  const consumeLine = (line: string) => {
    if (!line.trim()) return
    const event = JSON.parse(line)
    if (event.type === 'delta' && typeof event.delta === 'string') onDelta?.(event.delta)
    if (event.type === 'done' && event.reply && typeof event.reply === 'object') finalReply = event.reply
    if (event.type === 'error') throw new Error(event.message || t('svc.streamFailed'))
  }
  while (true) {
    const { done, value } = await reader.read()
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done })
    const lines = buffer.split('\n')
    buffer = lines.pop() || ''
    lines.forEach(consumeLine)
    if (done) break
  }
  consumeLine(buffer)
  if (!finalReply) throw new Error(t('svc.streamFailed'))
  return finalReply
}
